import { ExtendedDtoBasket } from '@epicuro-next/data/baskets-dto';
import { TaggedEntity } from '@epicuro-next/data/tagged-entities';
import { Basket } from 'graphql-api/baskets-api-interfaces';

import { aggregateTotals, getSizesTotal } from './mappings';
import { mapDtoStatus } from './shared';

type PropsForSummary = 'basketId' | 'orderReferenceNumber' | 'total' | 'status';

export type BasketSummary = Pick<Basket, PropsForSummary> & TaggedEntity;

export function getBasketSummary(basket: ExtendedDtoBasket): BasketSummary {
  const sizeTotals = getSizesTotal(basket.items);
  const { requested, confirmed } = aggregateTotals(sizeTotals);

  return {
    basketId: basket.basketId,
    orderReferenceNumber: basket.orderReferenceNumber,
    status: mapDtoStatus(basket.status),
    total: {
      requested: {
        ...requested,
        quantity: basket.summary.totalPiecesQuantity,
      },
      confirmed,
    },
    etag: basket.etag,
  };
}
